import helper from '../../service/helper';

export default function (value, param, _default = '') {
  if (helper.isEmpty(value)) {
    return null;
  }
  return helper.get(value, param, _default);
};
